import styled from 'styled-components';

export const Wrapper = styled.span<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  font-size: ${({ $size }) => `${$size / 16}rem`};
  font-weight: initial;
  line-height: 1;

  /* DUX-1153 Global Styles overrides:  .icon */
  .icon {
    width: 100%;
    height: 100%;
  }

  &.a-icon-branded {
    color: var(--t-non-interactive-accent-color);
  }
`;
